import React, { CSSProperties } from 'react'

type Props = {
  fill?: string
  stroke?: string
  width?: string
  height?: string
  viewBox?: string
  style?: CSSProperties
}

const IconTooltip = ({ fill = 'none', width = '100%', height = '100%', viewBox = '0 0 20 20', stroke = 'none', style }: Props) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} style={style}>
      <g fill="none" fillRule="evenodd">
        <circle cx="10" cy="10" r="9.5" stroke={stroke} />
        <path
          d="M10.45 12v-.451c0-.73.25-1.118 1.195-1.64.952-.534 1.555-1.305 1.555-2.395C13.2 6.084 11.92 5 10.045 5 7.954 5 6.8 6.18 6.8 8h1.273c0-1.18.796-1.917 1.92-1.917 1.108 0 1.823.632 1.823 1.493 0 .743-.335 1.18-1.198 1.674-1.02.57-1.475 1.194-1.468 2.111V12h1.3zM9.8 15c.57 0 1-.439 1-1 0-.57-.43-1-1-1-.561 0-1 .43-1 1 0 .561.439 1 1 1z"
          fill={fill}
        />
      </g>
    </svg>
  )
}

export default IconTooltip
